import { CSSProperties, useContext } from 'react'
import { SvgIconSheetContext } from '../context/svg-icon-sheet-provider'
import { SvgIconProps } from '@cinch-labs/design-system'

type SvgIconFromSheetProps = Omit<SvgIconProps, 'name'> & {
  name: string
  display?: CSSProperties['display']
  fill?: string
}

export const SvgIconFromSheet = ({
  name,
  size,
  color,
  display = 'block',
  className,
  fill,
}: SvgIconFromSheetProps) => {
  const svgIconSheetPath = useContext(SvgIconSheetContext)
  const svgIconPath = `${svgIconSheetPath}#${name}`
  return (
    <svg
      className={className}
      height={size}
      width={size}
      color={color}
      fill={fill}
      role="img"
      aria-hidden
      focusable={false}
    >
      <use href={svgIconPath} display={display} />
    </svg>
  )
}
